export default __webpack_public_path__ + "static/media/mg.246199b7.svg";